<script setup lang="ts">
import { ref } from "vue";
import { getCmsElementsFromCategory } from "~/server/apiBuilder";
const route = useRoute();

const layoutId = "0195d781c4d2716ea94061a9a374967e";

let cmsElementsFromCategory = ref();

cmsElementsFromCategory = await getCmsElementsFromCategory(layoutId);

const { hasShownWelcomePopup, closeWelcomePopup } = useWelcomePopup();

const popupContentElement = useTemplateRef("popupContentElement");
onClickOutside(popupContentElement, () => closeWelcomePopup());
</script>
<template>
  <Transition name="fade">
    <div
      v-if="!hasShownWelcomePopup"
      class="fixed inset-0 flex items-center justify-center bg-white bg-opacity-50 z-[100]"
    >
      <div
        class="bg-white rounded-lg shadow-lg max-w-full md:max-w-[70%] xl:max-w-[60%] [&_.container]:px-0"
        ref="popupContentElement"
      >
        <CmsPage
          v-if="cmsElementsFromCategory?.cmsPage"
          :content="cmsElementsFromCategory.cmsPage"
        />
      </div>
    </div>
  </Transition>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
